function Laos({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1489)">
        <path d="M30.4124 9.0435C27.8244 3.69156 22.3434 0 16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435L16 10.4348L30.4124 9.0435Z" fill="#D80027"/>
        <path d="M1.58765 22.9567C4.17565 28.3087 9.65664 32.0002 16 32.0002C22.3434 32.0002 27.8244 28.3087 30.4124 22.9567L16 21.5654L1.58765 22.9567Z" fill="#D80027"/>
        <path d="M30.4124 9.04346H1.58763C0.5705 11.1469 0 13.5068 0 16C0 18.4931 0.5705 20.853 1.58763 22.9565H30.4123C31.4296 20.853 32 18.4931 32 16C32 13.5068 31.4296 11.1469 30.4124 9.04346Z" fill="#0052B4"/>
        <path d="M16 21.5649C19.0736 21.5649 21.5652 19.0733 21.5652 15.9998C21.5652 12.9262 19.0736 10.4346 16 10.4346C12.9264 10.4346 10.4348 12.9262 10.4348 15.9998C10.4348 19.0733 12.9264 21.5649 16 21.5649Z" fill="#F0F0F0"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Laos;
